<template>
  <div class="bind-info">
    <el-form :model="bankInfo" ref="bankInfo">
      <el-form-item label="持卡人">
        <el-input v-model="bankInfo.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="bankInfo.id_card" disabled></el-input>
      </el-form-item>
      <el-form-item label="银行卡号">
        <el-input v-model="bankInfo.bank_card" disabled></el-input>
      </el-form-item>
      <el-form-item label="所属银行">
        <el-input v-model="bankInfo.bank_name" disabled></el-input>
      </el-form-item>

      <el-form-item label="预留手机号">
        <el-input v-model="bankInfo.phone" disabled></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-confirm btn" @click="$router.push({ name: 'bindForm' })">
      修改银行卡信息
    </div>
  </div>
</template>

<script>
import { getBankInfo } from '@/api/income';
import { mapState } from 'vuex';
export default {
  name: 'bindInfo',
  data() {
    return {};
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['bankInfo']),
  },
  methods: {
    init() {
      // 绑定成功后更新数据
      if (this.$route.params.update) {
        this.fetchKfzInfo();
      }
    },
    async fetchKfzInfo() {
      const res = await getBankInfo();
      this.$store.commit('SET_BANK_INFO', res.data);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.el-form-item {
  display: flex;
  margin-bottom: 38px;
  .el-input {
    width: 360px;
    height: 40px;
  }
  ::v-deep .el-form-item__label {
    padding-right: 40px;
    font-size: 16px;
    width: 120px;
  }
}
.bind-info {
  margin: 0 auto;

  .btn-confirm {
    width: 200px;
    height: 50px;
    color: #ffffff;
    font-size: 20px;
    border-radius: 8px;
    background: $--color-primary;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    margin-top: 73px;
  }
}
.btn {
  cursor: pointer;
  &:hover {
    filter: brightness(105%);
  }
}
.btn-forbid {
  cursor: not-allowed;
  background: #d9d9d9 !important;
  &:hover {
    filter: brightness(100%);
  }
}
</style>
